import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/post-component/post-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/_partials/header/journal-header.tsx");
